(function(root){
  'use strict';

  function endpoint(base,term){
    var rootPath=String(base||'/');
    if(rootPath.slice(-1)!=='/')rootPath+='/' ;
    var params=new URLSearchParams();
    params.set('q',String(term||'').trim());
    params.set('resources[type]','product');
    params.set('resources[limit]','10');
    params.set('resources[options][unavailable_products]','hide');
    params.set('section_id','predictive-search');
    return rootPath+'search/suggest?'+params.toString();
  }

  async function request(fetcher,base,term,ticket,isCurrent){
    var clean=String(term||'').trim();
    if(clean.length<2)return null;
    var response=await fetcher(endpoint(base,clean),{headers:{Accept:'text/html'}});
    if(!response.ok)throw new Error('Predictive search '+response.status);
    var text=await response.text();
    return isCurrent(ticket)?text:null;
  }

  function eventDetail(raw){
    raw=raw||{};
    var detail={};
    var handle=String(raw.handle||'').trim();
    var category=String(raw.category||'').trim();
    var position=parseInt(raw.position,10);
    var count=parseInt(raw.resultCount,10);
    if(/^[a-z0-9][a-z0-9-]{0,120}$/.test(handle))detail.item_id=handle;
    if(category)detail.item_category=category.slice(0,40);
    if(Number.isFinite(position)&&position>0&&position<=10)detail.position=position;
    if(Number.isFinite(count)&&count>=0&&count<=10)detail.result_count=count;
    return detail;
  }

  function returnFocusTarget(button){
    var mobile=button&&button.closest?button.closest('.be-nav__mobile'):null;
    return mobile&&mobile.querySelector?mobile.querySelector('summary')||button:button;
  }

  root.LarrysaPredictiveSearch={endpoint:endpoint,request:request,eventDetail:eventDetail,returnFocusTarget:returnFocusTarget};
  if(!root.document)return;

  var document=root.document;

  function translate(){
    if(typeof root.larrysaApplyLang==='function')root.larrysaApplyLang();
  }

  function track(name,raw){
    if(typeof root.LTrack==='function')root.LTrack(name,eventDetail(raw));
  }

  function initSearch(nav){
    var dialog=nav.querySelector('[data-search-dialog]');
    if(!dialog)return;
    var openers=nav.querySelectorAll('[data-search-open]');
    var close=dialog.querySelector('[data-search-close]');
    var form=dialog.querySelector('[data-search-form]');
    var input=dialog.querySelector('[data-search-input]');
    var start=dialog.querySelector('[data-search-start]');
    var results=dialog.querySelector('[data-search-results]');
    var recent=dialog.querySelector('[data-search-recent]');
    var recentList=dialog.querySelector('[data-search-recent-list]');
    var opener=null;
    var timer=0;
    var latest=0;

    function showStart(){
      latest+=1;
      results.hidden=true;
      results.removeAttribute('aria-busy');
      results.replaceChildren();
      start.hidden=false;
    }

    function renderRecent(){
      recentList.replaceChildren();
      var products=root.LarrysaRecentProducts&&root.LarrysaRecentProducts.read?root.LarrysaRecentProducts.read():[];
      recent.hidden=products.length===0;
      products.forEach(function(product,index){
        var link=document.createElement('a');
        link.href=product.href;
        link.setAttribute('data-search-recent','');
        link.setAttribute('data-handle',product.handle);
        link.setAttribute('data-category',product.category||'');
        link.setAttribute('data-position',String(index+1));
        if(product.image){
          var image=document.createElement('img');
          image.src=product.image;image.alt='';image.loading='lazy';
          link.appendChild(image);
        }
        var copy=document.createElement('span');
        var name=document.createElement('strong');name.textContent=product.name;copy.appendChild(name);
        if(product.price){var price=document.createElement('small');price.textContent=product.price;copy.appendChild(price);}
        link.appendChild(copy);recentList.appendChild(link);
      });
      translate();
    }

    function showError(){
      results.replaceChildren();
      var message=document.createElement('p');
      message.textContent='Não foi possível carregar sugestões. Pode pesquisar na mesma.';
      results.appendChild(message);
      results.hidden=false;
      results.removeAttribute('aria-busy');
      start.hidden=true;
      translate();
    }

    function showLoading(){
      results.replaceChildren();
      var message=document.createElement('p');
      message.className='be-search-panel__status';
      message.textContent='A procurar…';
      results.appendChild(message);
      results.hidden=false;
      results.setAttribute('aria-busy','true');
      start.hidden=true;
      translate();
    }

    function render(html){
      var parsed=new DOMParser().parseFromString(html,'text/html');
      var content=parsed.querySelector('[data-predictive-results]');
      if(!content)throw new Error('Predictive search markup missing');
      content.setAttribute('data-result-count',String(content.querySelectorAll('[data-search-suggestion]').length));
      results.replaceChildren(content);
      results.hidden=false;
      results.removeAttribute('aria-busy');
      start.hidden=true;
      translate();
    }

    function search(){
      root.clearTimeout(timer);
      var term=input.value.trim();
      if(term.length<2){showStart();return;}
      var ticket=++latest;
      showLoading();
      timer=root.setTimeout(function(){
        request(root.fetch,(root.Shopify&&root.Shopify.routes&&root.Shopify.routes.root)||'/',term,ticket,function(value){return value===latest;})
          .then(function(html){if(html)render(html);})
          .catch(function(){if(ticket===latest)showError();});
      },220);
    }

    openers.forEach(function(button){
      button.addEventListener('click',function(){
        var mobile=button.closest('.be-nav__mobile');
        opener=returnFocusTarget(button);
        if(mobile)mobile.open=false;
        renderRecent();
        if(!dialog.open)dialog.showModal();
        input.focus();
        track('search_open',{});
      });
    });
    close.addEventListener('click',function(){dialog.close();});
    dialog.addEventListener('click',function(event){
      if(event.target===dialog){dialog.close();return;}
      var clearSearch=event.target.closest&&event.target.closest('[data-search-clear]');
      if(clearSearch){input.value='';showStart();input.focus();return;}
      var category=event.target.closest&&event.target.closest('[data-search-category]');
      if(category){track('search_category_click',{category:category.getAttribute('data-search-category')});return;}
      var suggestion=event.target.closest&&event.target.closest('[data-search-suggestion],[data-search-recent]');
      if(suggestion)track(suggestion.hasAttribute('data-search-recent')?'search_recent_click':'search_suggestion_click',{
        handle:suggestion.getAttribute('data-handle'),category:suggestion.getAttribute('data-category'),position:suggestion.getAttribute('data-position')
      });
    });
    dialog.addEventListener('close',function(){if(opener)opener.focus();});
    input.addEventListener('input',search);
    form.addEventListener('submit',function(){
      var content=results.querySelector('[data-predictive-results]');
      track('search_submit',{resultCount:content?content.getAttribute('data-result-count'):0});
    });
    function syncPreferences(){if(dialog.open)renderRecent();}
    document.addEventListener('visitorConsentCollected',syncPreferences);
    document.addEventListener('larrysa:privacy',syncPreferences);
  }

  function init(){
    var footerGroups=document.querySelectorAll('[data-footer-group]');
    if(footerGroups.length){
      var compactFooter=window.matchMedia('(max-width:700px)');
      function syncFooter(){footerGroups.forEach(function(group){group.open=!compactFooter.matches;});}
      syncFooter();compactFooter.addEventListener('change',syncFooter);
    }
    document.querySelectorAll('.be-nav').forEach(function(nav){
      if(nav.dataset.navigationReady)return;nav.dataset.navigationReady='true';
      var menus=nav.querySelectorAll('.be-nav__catalogue,.be-nav__mobile');
      nav.addEventListener('keydown',function(event){
        if(event.key!=='Escape')return;
        menus.forEach(function(menu){if(menu.open){menu.open=false;menu.querySelector('summary').focus();event.preventDefault();}});
      });
      document.addEventListener('click',function(event){if(!nav.contains(event.target))menus.forEach(function(menu){menu.open=false;});});
      nav.addEventListener('focusout',function(event){if(event.relatedTarget&&!nav.contains(event.relatedTarget))menus.forEach(function(menu){menu.open=false;});});
      initSearch(nav);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})(typeof window!=='undefined'?window:globalThis);
